export default __webpack_public_path__ + "static/media/medical_icon.a803a068.svg";